import React from 'react';
import { t } from '../../i18n/languages';

const DeleteConfirmModal = ({
  show,
  item,
  onClose,
  onConfirm,
  currentLanguage,
  itemName = 'item', // default fallback text
}) => {
  if (!show || !item) return null;

  const formattedDate = item.date?.split('T')[0] || item.date;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h3 style={titleStyle}>
          {t('confirmDeletion', {}, currentLanguage)}
        </h3>

        <p style={textStyle}>
          {t('deleteWarning', { itemName, formattedDate }, currentLanguage)}
          {item.description && (
            <span style={descriptionStyle}>"{item.description}"</span>
          )}
        </p>

        <div style={buttonRowStyle}>
          <button type="button" onClick={onClose} style={cancelBtnStyle}>
            {t('cancel', {}, currentLanguage)}
          </button>
          <button type="button" onClick={onConfirm} style={deleteBtnStyle}>
            {t('remove', {}, currentLanguage)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;

// --------------------------- Styles ---------------------------

const overlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '24px',
  borderRadius: '12px',
  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
  maxWidth: '400px',
  width: '90%'
};

const titleStyle = {
  margin: '0 0 16px 0',
  fontSize: '18px',
  fontWeight: '600',
  color: '#1f2937'
};

const textStyle = {
  margin: '0 0 24px 0',
  color: '#6b7280',
  lineHeight: '1.5'
};

const descriptionStyle = {
  display: 'block',
  marginTop: '8px',
  fontStyle: 'italic'
};

const buttonRowStyle = {
  display: 'flex',
  gap: '12px',
  justifyContent: 'flex-end'
};

const cancelBtnStyle = {
  padding: '8px 16px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  backgroundColor: 'white',
  color: '#374151',
  cursor: 'pointer',
  fontSize: '14px'
};

const deleteBtnStyle = {
  padding: '8px 16px',
  border: 'none',
  borderRadius: '6px',
  backgroundColor: '#dc2626',
  color: 'white',
  cursor: 'pointer',
  fontSize: '14px'
};
